export default {
    data,
    mounted,
    methods: getMethods()
};

function data(){
    return {
        apiErrors: [],
        successMessages: [],
        isVerifyingEmail: false,
        isEmailVerified: false,
    };
}

function mounted(){
    const vm = this;
    const emailToVerify = vm.$route.query.email;
    const verificationToken = vm.$route.query.token;
    if(emailToVerify && verificationToken){
        vm.verifyEmailAddress({ email: emailToVerify, token: verificationToken });
    }
}

function getMethods(){
    return {
        displayApiErrors,
        verifyEmailAddress,
    };

    function displayApiErrors({ appMessage }){
        const vm = this;
        if(appMessage){
            vm.apiErrors = [appMessage];
        }
    }

    function verifyEmailAddress(payload){
        const vm = this;
        vm.isVerifyingEmail = true;
        Vue.appApi().guest().user().verifyEmailAddress(payload).then(displaySuccess).catch(vm.displayApiErrors).finally(resetSpinner);

        function displaySuccess(){
            vm.isEmailVerified = true;
            vm.successMessages = ['Thank you, your email address has been verified successfully.'];
        }
        function resetSpinner(){
            vm.isVerifyingEmail = false;
        }
    }
}
